import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';

export interface LogMetadataResponse {
	healthy: boolean;
	criticalErrorsThisMonth: number;
	month: number;
	year: number;
	periodStart: string;
	periodEnd: string;
	statuses: Record<string, string>;
	logTypes: Record<string, string>;
}

export const useGetLogMetadata = () =>
	useQuery<LogMetadataResponse>({
		queryKey: ['log-metadata'],
		queryFn: async () => {
			try {
				const { data } = await api.get<LogMetadataResponse>('/management/log/metadata');

				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao buscar metadados dos logs.');
			}
		},
	});
